<template>
  <div class="helpCenter">
     <v-topBar :yellowPageColumn='yellowPageColumn' :productAndSolutionColumn='productAndSolutionColumn' :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"> </v-topBar>
    <div class="setNavBg">
      <v-header :navigationColumnInfos='navigationColumnInfos' :webConfigInfo='webConfigInfo'  :hitSearchUrl='hitSearchUrl' :enterpriseResourceBaseUrl="enterpriseResourceBaseUrl"></v-header>
    </div>
    <v-publicBanner :bannerInfo="bannerInfo"></v-publicBanner>
    <div class="helpCenterCon">
      <ul class="clearfix">
        <li class="pull-left" v-for="(helpCenter,index) in helpCenterColumnInfos" :key="index">
          <h3>{{helpCenter.columnName}}</h3>
          <ul>
            <li v-for="(helpCenterChild,childIndex) in helpCenter.children" :key="childIndex">
              <a v-if="helpCenterChild.children" @click="goToDetail(helpCenterChild.children[0].columnId)"><span>{{helpCenterChild.columnName}}</span></a>
              <a v-else @click="goToDetail(helpCenterChild.columnId)"><span>{{helpCenterChild.columnName}}</span></a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <v-footer :webConfigInfo='webConfigInfo' :footerColumnInfos="footerColumnInfos"></v-footer>
    <v-backToTop></v-backToTop>
  </div>
</template>
<script>
import header from '@/components/v-header/header'
import topBar from '@/components/topBar'
import publicBanner from '@/components/publicBanner'
import messageTable from '@/components/messageTable'
import bootPage from '@/components/bootPage'
import footer from '@/components/v-footer'
import backToTop from '@/components/backToTop'

export default {
  props: [],
  data () {
    return {
      navInfo: {},
      bannerInfo: {title: '帮助中心',content: "Help center"},
      webConfigInfo: {},
      footerColumnInfos:[],
      helpCenterColumnInfos:[],
      helpCenterInfo:{},
      navigationColumnInfos:[],
      paramInfo:{},
      hitSearchUrl:'',
      enterpriseResourceBaseUrl:'',
      yellowPageColumn:{},
      productAndSolutionColumn:{}
    }
  },
  components: {
    'v-header': header,
    'v-topBar': topBar,
    'v-publicBanner': publicBanner,
    'v-messageTable': messageTable,
    'v-bootPage': bootPage,
    'v-footer': footer,
    'v-backToTop': backToTop
  },
  created () {
    this.$axios.post('/onelink.mdata.main.api/helpCenter/findHelpCentorInfo', {
      columnType: 0
    }).then((res) => {
      this.data = res.data;
      this.helpCenterColumnInfos = this.data.helpCenterColumnInfos;
      this.webConfigInfo = this.data.webConfigInfoDto;
      this.footerColumnInfos = this.data.footerColumnInfos;
      this.navigationColumnInfos = this.data.navigationColumnInfos;
      this.helpCenterInfo = res.data;
      this.yellowPageColumn = this.data.yellowPageColumn;
      this.productAndSolutionColumn = this.data.productAndSolutionColumn;
      this.hitSearchUrl = this.data.hitSearchUrl;
      this.enterpriseResourceBaseUrl = this.data.enterpriseResourceBaseUrl;
    }).catch((err) => {
        console.log(err)
    })
  },
  mounted () {
    
  },
  methods: {
    goToDetail(columnId){
      this.$router.push({path: '/helpDetails',query:{columnId:columnId}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/helpCenter/index.vue